import { InjectableClass } from "@fino/lib-injection";
import { Features } from "../../common/config/feature.constants";

export class FinishService extends InjectableClass {
	constructor($http, FileSaver, $timeout, configService, appConfig) {
		"ngInject";
		super({
			$http,
			$timeout,
			FileSaver,
			configService,
			appConfig,
		});
	}
	askForDocuments(orderId, jwt) {
		return this.$http.get(`${this.api}/orders/${orderId}`, {
			headers: {
				"FINO-AUTHORIZATION": jwt,
			},
		});
	}

	get isAsyncProccessingActive() {
		return this.configService.isFeatureActive(Features.asyncProcessing);
	}

	get api() {
		return this.appConfig.get().api.path;
	}

	downloadLetter(url) {
		return this.$http({
			method: "GET",
			url: url,
			responseType: "arraybuffer",
		}).then((response) => {
			const blob = new Blob([response.data], { type: "application/pdf" });
			this.FileSaver.saveAs(blob, "depotuebertrag.pdf");
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/finish/finish.service.js